module.exports = __webpack_public_path__ + "img/12-fourImg.67c36f38.png";